import React, { useEffect, useRef, useState } from 'react';
import { nameserver } from '../../../config/nameServer';

export const MobileEditForm = ({ initData, onDataChanged }) => {
  const [data, setData] = useState<any>(null);
  const API_URL = nameserver;
  const [fullName] = useState(localStorage.getItem('fullname') || '');
  const recognitionRef = useRef<any>(null);
const [isListening, setIsListening] = useState(false);
  const SpeechRecognition =
    (window as any).SpeechRecognition ||
    (window as any).webkitSpeechRecognition;

  const isSpeechSupported = !!SpeechRecognition;
  useEffect(() => {
    if (!initData) return;

    // Nếu KET_QUA = 'Not OK' mà TRANG_THAI_THIET_BI trống, gán mặc định
    let newData = { ...initData };
    if (newData.KET_QUA === 'Not OK' && !newData.TRANG_THAI_THIET_BI) {
      newData.TRANG_THAI_THIET_BI = 'Đang chạy'; // hoặc lấy từ initData nếu có giá trị
    }

    setData(newData);
  }, [initData]);

  if (!data) return null;

  const updateData = (newData) => {
    setData(newData);
    onDataChanged(newData);
  };
  const startVoiceInput = () => {
  console.log('click mic');

  if (!SpeechRecognition) {
    alert('Trình duyệt không hỗ trợ giọng nói');
    return;
  }

  // Nếu đang ghi âm thì không chạy tiếp
  if (isListening) return;

  const recognition = new SpeechRecognition();

  recognitionRef.current = recognition;

  recognition.lang = 'vi-VN';
  recognition.continuous = true;
  recognition.interimResults = false;

  recognition.start();

  recognition.onstart = () => {
    console.log('Mic started');

    setIsListening(true);

    // Xóa nội dung cũ khi bắt đầu nói
    setData((prev: any) => {
      const newData = {
        ...prev,
        DE_XUAT: '',
      };

      onDataChanged(newData);

      return newData;
    });
  };

  recognition.onresult = (event: any) => {
    console.log('result', event);

    const text =
      event.results[event.results.length - 1][0].transcript;

    setData((prev: any) => {
      const newData = {
        ...prev,
        DE_XUAT: text,
      };

      onDataChanged(newData);

      return newData;
    });
  };

  recognition.onerror = (event: any) => {
    console.log('speech error', event);

    alert(event.error);

    setIsListening(false);
  };

  recognition.onend = () => {
    console.log('speech end');

    setIsListening(false);
  };
};
const stopVoiceInput = () => {
  if (recognitionRef.current) {
    recognitionRef.current.stop();
    recognitionRef.current = null;
  }

  setIsListening(false);
};
  // 🔥 Hàm chuẩn hóa URL
  function getSafeUrl(url: string) {
    if (!url) return '';
    // Nếu đã có http:// hoặc https:// thì giữ nguyên
    if (/^https?:\/\//i.test(url)) return url;
    // Nếu chỉ có /uploads/abc.jpg thì ghép API_URL
    return API_URL.replace(/\/$/, '') + '/' + url.replace(/^\//, '');
  }

  return (
    <div
      style={{
        // background: '#f5f7fa',
        minHeight: '100%',
      }}
    >
      {/* THÔNG TIN */}
      <h3>{data.TEN_THIET_BI}</h3>
      <p>
        <b>Bộ phận:</b> {data.TEN_BO_PHAN}
      </p>
      <p>
        <b>Nội dung:</b> {data.NOI_DUNG_KIEM_TRA}
      </p>
      <p>
        <b>Tiêu chuẩn:</b> {data.TIEU_CHUAN}
      </p>
      <p>
        <b>Ca:</b> {data.CA}
      </p>
      <p>
        <b>Người kiểm tra:</b> {data.CREATED_BY}
      </p>
      {data.NGAY_SUA && (
        <p>
          <b>Thời gian:</b>{' '}
          {new Date(data.NGAY_SUA).toLocaleString('vi-VN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })}
        </p>
      )}

      {/* OK / NOT OK */}
      <div style={{ marginTop: 15 }}>
        <b>Kết quả:</b>
        <div style={{ marginTop: 8 }}>
          <button
            onClick={() =>
              updateData({
                ...data,
                KET_QUA: 'OK',
                DE_XUAT: '',
                ANH: null,
                TRANG_THAI_THIET_BI: 'Đang chạy',
              })
            }
            style={{
              background: data.KET_QUA === 'OK' ? 'green' : '#ccc',
              color: 'white',
              padding: 10,
              marginRight: 10,
            }}
          >
            OK
          </button>

          <button
            onClick={() =>
              updateData({
                ...data,
                KET_QUA: 'Not OK',
                TRANG_THAI_THIET_BI: 'Thiết bị dừng',
              })
            }
            style={{
              background: data.KET_QUA === 'Not OK' ? 'red' : '#ccc',
              color: 'white',
              padding: 10,
            }}
          >
            Not OK
          </button>
        </div>
      </div>

      {/* TRẠNG THÁI THIẾT BỊ */}
      {data.KET_QUA === 'Not OK' && (
        <div style={{ marginTop: 15 }}>
          <b>Trạng thái thiết bị:</b>
          <select
            value={data.TRANG_THAI_THIET_BI || ''}
            onChange={(e) =>
              updateData({
                ...data,
                TRANG_THAI_THIET_BI: e.target.value,
              })
            }
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          >
            <option value=''>-- Chọn --</option>
            <option value='Đang chạy'>Đang chạy</option>
            <option value='Thiết bị dừng'>Thiết bị dừng</option>
          </select>
        </div>
      )}

      {/* ĐỀ XUẤT */}
      {data.KET_QUA === 'Not OK' && (
        <div style={{ marginTop: 15 }}>
          <b>Đề xuất:</b>

          <textarea
            value={data.DE_XUAT || ''}
            onChange={(e) =>
              updateData({
                ...data,
                DE_XUAT: e.target.value,
              })
            }
            style={{
              width: '100%',
              minHeight: 100,
              marginTop: 5,
              padding: 12,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 16,
            }}
          />

         {isSpeechSupported && (
  <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
    <button
      type='button'
      onClick={startVoiceInput}
      disabled={isListening}
      style={{
        flex: 1,
        padding: '12px',
        border: 'none',
        borderRadius: 10,
        background: isListening ? '#999' : '#1976d2',
        color: '#fff',
        fontWeight: 600,
        cursor: 'pointer',
        fontSize: 16,
      }}
    >
      🎤 Bắt đầu nói
    </button>

    <button
      type='button'
      onClick={stopVoiceInput}
      disabled={!isListening}
      style={{
        flex: 1,
        padding: '12px',
        border: 'none',
        borderRadius: 10,
        background: !isListening ? '#999' : '#d32f2f',
        color: '#fff',
        fontWeight: 600,
        cursor: 'pointer',
        fontSize: 16,
      }}
    >
      ⏹ Dừng
    </button>
  </div>
)}
        </div>
      )}

      {/* ẢNH */}
      <div style={{ marginTop: 15 }}>
        <label
          htmlFor='camera-upload'
          style={{
            display: 'inline-block',
            padding: '12px 16px',
            background: '#1976d2',
            color: '#fff',
            borderRadius: 8,
            cursor: 'pointer',
            marginTop: 10,
          }}
        >
          📷 Chụp ảnh
        </label>

        <input
          id='camera-upload'
          type='file'
          accept='image/*'
          capture='environment'
          style={{ display: 'none' }}
          onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
            if (!e.target.files || e.target.files.length === 0) return;

            const file = e.target.files[0];

            const form = new FormData();
            form.append('file', file);

            const res = await fetch(API_URL + '/api/upload', {
              method: 'POST',
              body: form,
            });

            const result = await res.json();

            updateData({
              ...data,
              ANH: result.url,
            });
          }}
        />

        {data.ANH && (
          <img
            src={getSafeUrl(data.ANH)}
            style={{
              width: '100%',
              marginTop: 10,
              borderRadius: 8,
              cursor: 'pointer',
            }}
            onClick={() => window.open(getSafeUrl(data.ANH), '_blank')}
          />
        )}
      </div>
    </div>
  );
};
